import { gql } from "@apollo/client";
import { PRORATION_FRAGMENT } from "../../[orderId]/queries";
import { CRM_NOTE_FIELDS_FRAGMENT } from "@/fragments";

export const PAYMENT_QUERY = gql`
  query commercePayment($paymentId: ID!) {
    commercePayment(id: $paymentId) {
      id
      amountCents
      refundedAmountCents
      type
      paidAt
      source
      status
      transactionId
      transactionUrl
      stripeAccount
      referenceNumber
      payer {
        id
        name
        email
      }
      orderPayments {
        id
        amountCents
        ledgerEntries {
          amountCents
          createdAt
          type
          secondaryLineItem {
            id
            name
            priceCents
          }
          lineItem {
            id
            name
            balance
            priceCents
            proratable
            proration {
              ...ProrationFragment
            }
          }
        }
        order {
          id
          status
          balance
          totalPaid
          description
          dueDate
          updatedAt
          lineItems {
            id
            name
            totalPrice
            priceCents
            balance
            quantity
          }
          person {
            id
            firstName
            lastName
            profilePhoto
            pgaId
            mainProgramType {
              name
            }
          }
        }
      }
      notes {
        ...CRMNoteFields
      }
    }
  }

  ${PRORATION_FRAGMENT}
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;

export const COMMERCE_PAYMENT_AUDIT_LOG_QUERY = gql`
  query PaymentAuditLog($paymentId: ID!) {
    commercePaymentAuditLog(paymentId: $paymentId) {
      id
      timestamp
      eventType
      description
      actor {
        __typename
        ... on BackofficeUser {
          id
          email
          name
        }
        ... on BackofficeAdminUser {
          id
          email
        }
        ... on BackofficePerson {
          id
          displayName
        }
      }
      entity {
        __typename
        ... on CommercePayment {
          id
        }
        ... on CommerceRefund {
          id
        }
      }
      person {
        id
      }
      changeset {
        id
        typeOfData
        oldValue
        newValue
      }
    }
  }
`;
